if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      static SECONDS_PER_DAY = 60 * 60 * 24;
      static SECONDS_PER_HOUR = 60 * 60;
      static SECONDS_PER_MINUTES = 60;

      constructor() {
        super();
      }

      connectedCallback() {
        this.date = this.dataset.date;
        this.time = this.dataset.time || '00:00:00';
        this.targetDate = this.parseDate(this.date, this.time);
        this.resolution = parseInt(this.dataset.resolution);
        this.runningMsg = this.dataset.runningMessage || '{timer}';
        this.doneMsg = this.dataset.doneMessage || '';
        this.dayFormat = this.dataset.dayFormat || '{days}:';
        this.hourFormat = this.dataset.hourFormat || '{hours}:';
        this.minuteFormat = this.dataset.minuteFormat || '{minutes}:';
        this.secondFormat = this.dataset.secondFormat || '{seconds}';
        this.hideWhenDone = this.dataset.hideWhenDone === 'true';
        this.hideZeros = this.dataset.hideZeros === 'true';

        this.render();
        this.interval = setInterval(this.render.bind(this), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval)
      }

      parseDate(dateStr, timeStr) {
        const dateParts = dateStr.split('/');
        const timeParts = timeStr.split(':');

        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1], timeParts[2]);
      }

      render() {
        let remainingSeconds = Math.floor((this.targetDate.getTime() - Date.now()) / 1000);
        const isDone = remainingSeconds <= 0;

        const days = Math.floor(remainingSeconds / CountdownTimer.SECONDS_PER_DAY);
        remainingSeconds -= days * CountdownTimer.SECONDS_PER_DAY;

        const hours = Math.floor(remainingSeconds / CountdownTimer.SECONDS_PER_HOUR);
        remainingSeconds -= hours * CountdownTimer.SECONDS_PER_HOUR;

        const minutes = Math.floor(remainingSeconds / CountdownTimer.SECONDS_PER_MINUTES);
        remainingSeconds -= minutes * CountdownTimer.SECONDS_PER_MINUTES;

        const seconds = remainingSeconds;

        let timeStr = '';
        if (this.hideZeros) {
          if (days > 0) timeStr += this.dayFormat.replaceAll('{days}', days.toString().padStart(2, '0')) + "";
          if (hours > 0) timeStr += this.hourFormat.replaceAll('{hours}', hours.toString().padStart(2, '0')) + "";
          if (minutes > 0) timeStr += this.minuteFormat.replaceAll('{minutes}', minutes.toString().padStart(2, '0')) + "";
          if (seconds > 0) timeStr += this.secondFormat.replaceAll('{seconds}', seconds.toString().padStart(2, '0'));
        } else {
          timeStr += this.dayFormat.replaceAll('{days}', days.toString().padStart(2, '0')) + "";
          timeStr += this.hourFormat.replaceAll('{hours}', hours.toString().padStart(2, '0')) + "";
          timeStr += this.minuteFormat.replaceAll('{minutes}', minutes.toString().padStart(2, '0')) + "";
          timeStr += this.secondFormat.replaceAll('{seconds}', seconds.toString().padStart(2, '0'));
        }

        if (isDone) {
          clearInterval(this.interval)
          if (this.hideWhenDone) {
            this.classList.add('hidden')
          } else {
            this.innerHTML = this.doneMsg.replaceAll('{timer}', timeStr);
          }
        } else {
          this.innerHTML = this.runningMsg.replaceAll('{timer}', timeStr)
        }
      }
    }
  );
}
